module.exports = "/_next/static/images/feature2-e98f73ade08375603e3cce19ec9cc887.png";